import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M10 15.208c2.917 0 6.042-1.458 6.042-5.208S12.917 4.792 10 4.792 3.958 6.25 3.958 10c0 .858.164 1.596.451 2.224.18.392.28.824.2 1.247l-.218 1.165a.833.833 0 0 0 .973.973l2.673-.501c.21-.04.425-.036.636-.003.44.07.886.103 1.327.103Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M7.917 10a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Zm2.5 0a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Zm2.5 0a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);